module.exports = __webpack_public_path__ + "img/01_abe_06.572da8bf.jpg";